import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initState = {
  // curriculum pointers
  levelIndex: 0,
  questionIndex: 0,
  questionIdsInRound: [],
  // progress
  progressAmount: 0,
  // round props
  attemptsCount: 0,
  correctAnswers: [],
  isSummaryQuestionCorrect: false,
  // level props
  questionsCorrect: 0,
  questionCount: 0,
  // hints props
  isScaffoldingMode: false,
  hintId: null,
  revealedHints: [],
  // chunks
  chunks: [],
  chunksLayouts: [],
  // embedded measurement
  records: [],
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        levelIndex: payload,
      };

    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return {
        ...state,
        questionIndex: 0,
        questionIdsInRound: payload.questionIdsInRound,
        progressAmount: 0,
        attemptsCount: 0,
        correctAnswers: [],
        isSummaryQuestionCorrect: false,
        questionsCorrect: 0,
        questionCount: 0,
        isScaffoldingMode: false,
        hintId: null,
        revealedHints: [],
        chunks: [],
        chunksLayouts: [],
        records: [],
      };

    case REDUX_ACTIONS.RESUME_ROUND:
      return {
        ...initState,
        ...payload,
      };

    case REDUX_ACTIONS.INCREASE_PROGRESS:
      return {
        ...state,
        progressAmount: state.progressAmount + (100 / (state.questionIdsInRound.length + 1)),
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...state,
        questionIndex: Math.min(state.questionIndex + 1, state.questionIdsInRound.length - 1),
        attemptsCount: 0,
        correctAnswers: [],
        isScaffoldingMode: false,
        hintId: null,
        revealedHints: [],
        chunks: [],
        chunksLayouts: [],
      };

    case REDUX_ACTIONS.SELECT_RESPONSE: {
      const { correctAnswers } = payload;

      const attemptsCount = state.attemptsCount + 1;

      return {
        ...state,
        correctAnswers,
        attemptsCount,
        isScaffoldingMode: false,
      };
    }

    case REDUX_ACTIONS.TURN_SCAFFOLDING_MODE_ON: {
      const { revealedHints } = payload;

      return {
        ...state,
        isScaffoldingMode: true,
        // if previous hint was not filtered out after user marked relevant tag correctly - leave it as is
        // otherwise, pick 1st one if there are still some revealed hints, if no - set null
        hintId: revealedHints.includes(state.hintId) ? state.hintId : (revealedHints[0] || null),
        revealedHints,
      };
    }

    case REDUX_ACTIONS.SELECT_HINT: {
      const { hintId } = payload;

      return {
        ...state,
        hintId,
      };
    }

    case REDUX_ACTIONS.REVEAL_HINT: {
      const { hintId } = payload;

      return {
        ...state,
        hintId,
        revealedHints: [
          ...state.revealedHints,
          hintId,
        ],
      };
    }

    case REDUX_ACTIONS.SET_QUESTIONS_COUNT: {
      return {
        ...state,
        questionCount: state.questionCount + payload,
      };
    }

    case REDUX_ACTIONS.SET_CORRECT_QUESTIONS_COUNT: {
      return {
        ...state,
        questionsCorrect: state.questionsCorrect + payload,
      };
    }

    case REDUX_ACTIONS.SET_SUMMARY_QUESTION_ANSWER: {
      const attemptsCount = state.attemptsCount + 1;

      return {
        ...state,
        attemptsCount,
        isSummaryQuestionCorrect: payload,
      };
    }

    case REDUX_ACTIONS.REGISTER_CHUNKS_LAYOUT: {
      const { chunks, chunksLayouts } = payload;
      return {
        ...state,
        chunks,
        chunksLayouts,
      };
    }

    case REDUX_ACTIONS.QUICK_ROUND: {
      const numQuestions = state.questionIdsInRound.length;
      return {
        ...state,
        questionsCorrect: payload.pass ? numQuestions : 0,
        questionCount: numQuestions,
      };
    }

    case REDUX_ACTIONS.UPDATE_RECORDS:
      return {
        ...state,
        records: [...state.records, payload],
      };

    default:
      return state;
  }
};

export default roundPlayReducer;
